import rawDeviceMakes from "./deviceMakes.json";

export interface IDeviceMake {
  id: string;
  name: string;
  model: string;
  type: string;
  defaultUserPwd?: string | null;
  rtspTemplate: string;
  hasPanTilt: boolean;
  hasZoom?: boolean | null;
  modelsToRun: string[];
  deviceTypeShortName?: string | null;
}

export const DEVICE_MAKES: IDeviceMake[] = rawDeviceMakes as IDeviceMake[];

export const getDeviceMakeByModel = (model: string): IDeviceMake | undefined =>
  DEVICE_MAKES.find(m => m.model === model);
